import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash/fp';
import { connect } from 'react-redux';
import cns from 'classnames';

import HideIcon from 'components/icons/Hide.com.svg';
import * as actions from './actions';
import cn from './styles.local.less';

class DislikeAdButton extends PureComponent {
  static propTypes = {
    adId: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    dislikeAd: PropTypes.func.isRequired,
    isDislike: PropTypes.bool,
  };

  static defaultProps = {
    onClick: noop,
    isDislike: false,
  };

  state = {
    isLoading: false,
  };

  handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { adId, dislikeAd, isDislike, onClick } = this.props;

    this.setState({ isLoading: true }, () => {
      dislikeAd(adId, !isDislike)
        .then(() => {
          this.setState({ isLoading: false }, () => onClick(!isDislike));
        })
        .catch(() => {
          this.setState({ isLoading: false });
        });
    });
  };

  render() {
    const { isLoading } = this.state;
    const { isDislike } = this.props;

    return (
      <button
        className={cns(cn.root, {
          [cn.isLoading]: isLoading,
          [cn.active]: isDislike,
        })}
        onClick={this.handleClick}
        data-qa-selector="dislike-btn"
      >
        <HideIcon className={cn.icon} />
      </button>
    );
  }
}

export default connect(null, actions)(DislikeAdButton);
